<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="dedication" id="_idParaDest-1"><span class="bold _idGenCharOverride-1"><a id="_idTextAnchor000"></a>For my father</span></p>
<p class="text-indented ParaOverride-2"><span class="bold CharOverride-2">Peter C. Herring, LCSW</span></p>
<p class="text-indented ParaOverride-2"><span class="bold CharOverride-2">with love from your lamb chop</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-3-32.vue?06b3f67b